import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=b9b63752&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b63752')) {
      api.createRecord('b9b63752', component.options)
    } else {
      api.reload('b9b63752', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=b9b63752&", function () {
      api.rerender('b9b63752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vfxGzR4HdcIJ/JS/comp/openstreetmap.vue"
export default component.exports